import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { createLabel, updateLabel } from 'redux/smartchat/header/actions'
import LabelModalUI from './LabelModalUI'

const LabelModal = ({ isOpen, toggle, mode, labelId }) => {
  const { labelsList, modalLoading, modalError } = useSelector(store => store.smartchatHeader)
  const dispatch = useDispatch()
  const label = labelId && labelsList.find(label => label._id === labelId)
  const [labelName, setLabelName] = useState(label?.name || '')
  const [labelColor, setLabelColor] = useState(label?.color || '#E87721')

  const handleSave = () => {
    if (mode === 'add') {
      dispatch(createLabel({
        label: { name: labelName, color: labelColor },
        onFinish: toggle
      }))
    }

    if (mode === 'update') {
      dispatch(updateLabel({
        labelId,
        label: { ...label, name: labelName, color: labelColor },
        onFinish: toggle
      }))
    }
  }

  return (
    <LabelModalUI
      isOpen={isOpen}
      toggle={toggle}
      mode={mode}
      labelName={labelName}
      setLabelName={setLabelName}
      labelColor={labelColor}
      setLabelColor={setLabelColor}
      handleSave={handleSave}
      modalLoading={modalLoading}
      modalError={modalError}
    />
  )
}

export default LabelModal
